import React from "react";
import Fade from "react-reveal/Fade";
// Comps
// Css
import classes from "./Content.module.scss";

const Content: React.FC = () => {
  return (
    <div className={classes.wrapper}>
      <Fade top>
        <h2 className={classes.title}>tutorial</h2>
      </Fade>
      <p className={classes.desc}>
        1. Choose the number of players which is between 5-10. See the
        combination of liberals and fascists in the down side of the cards.
      </p>
      <p className={classes.desc}>2. Enter player names.</p>
      <p className={classes.desc}>
        3. Click on your name to secretly view your character. Click again to
        hide your character before passing the phone to the next player.
      </p>
      <p className={classes.desc}>
        IMPORTANT NOTICE: STARE AT THIS PAGE FOR AT LEAST 7 SECONDS TO DRAW ANY
        POSSIBLE SUSPICION AWAY FROM THOSE WHO HAVE FASCIST ROLES.
      </p>
      <p className={classes.desc}>
        4. When gameplay starts, the main screen will show:
      </p>
      <p className={classes.desc}>
        a. Policy Slots for Liberals and Facists respectively. When an election
        is won, the card fills a Policy Slot. Some slots carry Presidential
        Powers. When you win that election slot, you can use the power and enact
        the Policy for that particular slot.
      </p>
      <p className={classes.desc}>
        b. Policy Deck and Discard Pile. These two decks will automatically be
        shuffled and distributed again when the Policy Deck has less than 3
        cards.
      </p>
      <p className={classes.desc}>
        c. Action Buttons. You may carry out any of the 4 actions in the game,
        wherever applicable as detailed in rules of the game.
      </p>
      <p className={classes.desc}>
        5. The team who fills up all of their Policy Slots first wins. The game
        ends and players' characters will be revealed.
      </p>
    </div>
  );
};

export default Content;
